import {
  createAnswer,
  createQuestion,
  deleteAnswer,
  deleteQuestion,
  getAlerts,
  getAnswers,
  getFAQs,
  updateAnswer,
  updateQuestion,
  updateApi
} from '../../api/faq'

export default {
  FETCH_FAQS({
               commit
             }, params) {
    return new Promise((resolve, reject) => {
      getFAQs(params).then(res => {
        commit('SET_FAQS', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  CREATE_QUESTION(_, data) {
    return createQuestion(data)
  },

  UPDATE_QUESTION(_, data) {
    return updateQuestion(data)
  },

  UPDATE_API(_, data) {
    return updateApi(data)
  },

  DELETE_QUESTION(_, id) {
    return deleteQuestion(id)
  },

  //answers
  FETCH_ANSWERS({
                  commit
                }, params) {
    return new Promise((resolve, reject) => {
      getAnswers(params).then(res => {
        commit('SET_ANSWERS', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  CREATE_ANSWER(_, data) {
    return createAnswer(data)
  },

  UPDATE_ANSWER(_, data) {
    return updateAnswer(data)
  },

  DELETE_ANSWER(_, id) {
    return deleteAnswer(id)
  },

  // alerts
  FETCH_ALERTS({
                 commit
               }, params) {
    return new Promise((resolve, reject) => {
      getAlerts(params).then(res => {
        commit('SET_ALERTS', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
